import { LoginDM } from "../data_model/login_dm";
import Axios from "axios";
import ApiUtils from "../utils/api_utils";
const LoginSM = {
  state: {
    login: new LoginDM({}),
    token: "",
    orgData: {},
  },
  reducers: {
    setLoginData(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    /**
     * Login to Take Token Auth
     */
    async loginTokenAuth(payload) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/profiles/api/token-auth/`,
        payload,
        {
          headers: ApiUtils.getHeader({}),
          withCredentials: false,
        }
      )
        .then((response) => {
          const data = response.data;
          // data.organization_pwa_settings.show_main_menu = false;
          dispatch.LoginSM.setLoginData({ login: data, token: data.token });
          dispatch.ProfileSM.setProfile({ profile: data.user_details });
          result = {
            status: 200,
            message: "Login Success",
            data: data.organization_pwa_settings,
          };
        })
        .catch((error) => {
          result = {
            status: 400,
            message: error.response.data,
            data: {},
          };
        });

      return result;
    },

    /**
     * Login with Token
     */
    async loginWithToken({ pwa_token }, rootState) {
      return await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/users/current/auth/?pwa_token=${pwa_token}`,
        {
          headers: ApiUtils.getHeader({}),
          withCredentials: false,
        }
      );
    },

    /**
     * LogOut
     */

    async logout(payload, state) {
      dispatch({ type: "RESET_APP" });
      return true;
    },
    /**
     * get Data Organization By Slug
     */
    async getDataOrgBySlug(slug) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/web-login/${slug}/`,
        {
          headers: ApiUtils.getHeader({}),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = response.data;
          dispatch.LoginSM.setLoginData({ orgData: data });
          result = {
            status: 200,
            message: "Get Data Success",
            data: data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
            data: {},
          };
        });

      return result;
    },
  }),
};

export default LoginSM;
